export function parseProductFlag(value: unknown, label: string, defaultValue = false): boolean {
  if (value == null || String(value).trim() === '') return defaultValue;
  if (typeof value === 'boolean') return value;
  const normalized = String(value).trim().toLowerCase();
  if (['n', 'no', 'x', '0', 'false'].includes(normalized)) return false;
  if (['y', 'yes', 'o', '1', 'true'].includes(normalized)) return true;
  throw new Error(`${label}는 Y 또는 X로 입력해주세요.`);
}
